<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-8">
                <h4 class="m-b-0">Marketplace Partners</h4>
                <p class="text-muted m-t-0">Click view to see information such as billing info, invoices and more.</p>
            </div>
            <div class="col-4">

            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card" v-if="members.length>0">
                    <div class="card-body">
                        <b-table :busy="busy" :current-page="currentPage" :fields="fields"
                                 :items="members"
                                 :per-page="perPage"
                                 :sort-by="sortBy" :sort-desc="sortDesc" :sort-direction="sortDirection"
                                 responsive striped tbody-tr-class="rowClass">
                            <template #cell(biz_name)="data">
                                <b>{{data.value}}</b>
                            </template>
                            <template #cell(address)="data">
                                {{data.item.line1}}, {{data.item.line2}}, {{data.item.city}}, {{data.item.country}}
                            </template>
                            <template #cell(action)="data">
                                <i @click="member = data.item" class="text-danger font-18 fa fa-border fa-trash-alt" data-target="#confirmModal"
                                   data-toggle="modal" style="cursor: pointer;"
                                   title="Remove Partner"></i>
                            </template>
                        </b-table>
                    </div>
                    <div class="card-footer" v-if="totalRows>5">
                        <div class="row">
                            <div class="col">
                                <per-page v-model="perPage"/>
                            </div>
                            <div class="col-auto" v-if="totalRows>perPage">
                                <b-pagination :per-page="perPage" :total-rows="totalRows" v-model="currentPage"/>
                            </div>
                        </div>
                    </div>
                    <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="confirmModal"
                         role="dialog" tabindex="-1">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-body card-blue">
                                    <div class="text-center m-t-20 m-b-10">
                                        <i class="fa fa-exclamation-triangle text-warning" style="font-size:50px"></i>
                                        <br><br>
                                        <h4>Are you sure you want to remove {{member.biz_name}} from partnership?</h4>
                                        <button @click="removeMember()"
                                                class="btn waves-effect waves-light btn-success m-r-15"
                                                data-dismiss="modal" type="button">Yes
                                        </button>
                                        <button class="btn waves-effect waves-light btn-danger" data-dismiss="modal"
                                                type="button">No
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body" v-else>
                    <h4 class="card-title text-muted text-center">No records found</h4>
                </div>
            </div>
        </div>
        <div class="row" v-if="members.length>0">
            <div class="col-12">
                <paginate
                        :click-handler="pageHandler"
                        :container-class="'pagination float-right'"
                        :margin-pages="2"
                        :next-class="'page-link'"
                        :next-text="'Next'"
                        :page-class="'page-link'"
                        :page-count=pageCount
                        :page-range="3"
                        :prev-class="'page-link'"
                        :prev-text="'Prev'">
                </paginate>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Blockie from "../../common/Blockie";
    import Paginate from 'vuejs-paginate';

    export default {
        name: "Growers",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Blockie, Paginate},
        data() {
            return {
                members: [],
                pageCount: 1,
                total: 0,
                member: {
                    id: null,
                    biz_name: null
                },
                fields: [
                    {
                        key: 'biz_name',
                        label: 'Name',
                    },
                    {
                        key: 'address',
                        label: 'Address'
                    },
                    {
                        key: 'action',
                        label: 'Action',
                    }
                ],
                busy: false,
                currentPage: 1,
                perPage: 5,
                totalRows: 0,
                sortBy: 'name',
                sortDesc: false,
                sortDirection: 'asc',
            };
        },
        mounted() {
            this.getMembers(1);
        },
        methods: {
            getMembers(page) {
                $(".preloader").fadeIn();
                this.$http
                    .get("/marketplaces/" + this.currentOrg.marketplace_id + "/members", {
                        params: {
                            page: page,
                            perPage: 10
                        }
                    })
                    .then(reply => {
                        $(".preloader").fadeOut();
                        this.total = reply.data.total;
                        this.members = reply.data.members;
                        //this.setPageCount();
                    })
                    .catch(err => {
                        $(".preloader").fadeOut();
                        console.log(err);
                    });
            },
            async getPurchase() {
                let purchase = await this.$http
                    .get("/marketplaces/" + this.currentOrg.marketplace_id + "/members/purchasesReport");
                console.log(purchase);
            },
            pageHandler(pageNum) {
                this.getMembers(pageNum);
            },
            setPageCount() {
                this.pageCount = this.total <= 10 ? 1 : Math.ceil(this.total / 10);
            },
            async removeMember() {
                try {
                    await this.$http.delete(`marketplaces/${this.currentOrg.marketplace_id}/plans/${this.member.plan_id}/members`, {data: {org_id: this.member.id}});
                    this.$toastr('success', `${this.member.biz_name} successfully removed from your partership`, 'Member Removed');
                    await this.getMembers(1);
                } catch (e) {
                    this.$toastr('error', `Failed to remove ${this.member.biz_name}`, 'Failed');
                }
            }
        }
    }
</script>

<style scoped>

</style>
